/* eslint-disable */
require('./kiosk')
require('./provtagning')
require('./pws')
require('./self-check')
require('./toilet')
